// Small presentational pieces the master screens share, so every list and form
// looks like the product-master design. Display only - no state, no data access.
import React from "react";
import { pmHue, pmInitials } from "../modal/Product/pmUi";

// A list row's first cell: the initials tile plus the name (and an optional
// second line). Used as a column `render`, so sorting and the exports, which
// read `dataIndex` off the raw row, are unaffected.
export const MasterName = ({ text, sub }) => (
  <span className="ax-namecell">
    <span className="ax-thumb" style={{ "--h": pmHue(text) }}>
      {pmInitials(text)}
    </span>
    <span className="ax-nmain">
      <span className="ax-nname">{text}</span>
      {sub ? <span className="ax-nsub">{sub}</span> : null}
    </span>
  </span>
);

// The "0 items" chip beside the page title.
export const CountChip = ({ count, noun = "items" }) => (
  <span className="ax-count">
    {Number(count || 0).toLocaleString("en-US")} {noun}
  </span>
);

// New / Edit badge in the form header.
export const FormPill = ({ mode }) => (
  <span className={"ax-pill " + (mode === "edit" ? "saved" : "new")}>
    {mode === "edit" ? "Edit" : "New"}
  </span>
);

// Left-hand note on the form's button row.
export const FormHint = ({ children }) => (
  <span className="ax-formhint">
    {children || "Fields marked * are required"}
  </span>
);
